import { AuthContext } from '@repo-level/core-front';
import { ModalsContext, ModalType } from 'contexts/modal';
import { useContext, useEffect } from 'react';
import { isNeedAuthDataConfirmation } from '../helpers/authFields';
import { useIsProviderAccount } from './useIsProviderAccount';

export const useGoogleDataConfirmation = () => {
  const { user, pendingUser } = useContext(AuthContext);
  const { handleModal, modals } = useContext(ModalsContext);

  const isConfirmationRequired = isNeedAuthDataConfirmation(user);
  const isProviderAccount = useIsProviderAccount(isConfirmationRequired);

  useEffect(() => {
    if (pendingUser || modals.length) return;
    if (!(isConfirmationRequired && isProviderAccount)) return;

    handleModal(ModalType.ConfirmGoogleRegistration, {
      stayInSameWindow: true,
    })();
  }, [
    handleModal,
    isConfirmationRequired,
    isProviderAccount,
    modals.length,
    pendingUser,
  ]);
};
